<app-ice-visuals-dashboard-table-display
    [columns]="columns"
    [loading]="dataService.loading()"
    [data]="listings()"
    [state]="widgetState()"
    [maxRows]="8"
    [totalRows]="totalListings()"
    [totalItemsTranslationKey]="'dashboard.visuals.components.table.totalItems.neverPublishedListings'"
    [emptyMessageTranslationKey]="'dashboard.visuals.components.table.noData.neverPublishedListings'"
/>
